import React, { useEffect, useState } from "react";
import BomTable, { ProductImageCell } from "./BomTable";

function BomData() {
  let [products, setProducts] = useState({
    count: 4,
  });

  var counter = 5;
  console.log("outside count", products.count);
  const handleChange = (e) => {
    console.log("inside handel chnage count", products.count);
    if (e.target.value > 0) {
      setProducts({ count: e.target.value || 0 });
    } else {
      console.log("out of stock");
    }
  };

  const decrease = (e) => {
    if (products.count <= 0) {
      return;
    }
    console.log("count in decrease", products.count);
    console.log("e.target.value", e.target.value);

    if (e.target.value > 0) {
      counter = counter - parseInt(e.target.value);
      if (counter == 0 || counter < 0) {
        alert("out of stock");
        counter = 0;
      }
      setProducts({ count: products.count - e.target.value });
      console.log("inside if", products.count);
    } else {
      console.log("out of stock");
    }
    console.log("count", products.count);
  };

  const data = [
    {
      id: "1",
      number: "10254354545",
      itemname: "Dutch Grown",
      desc:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.",
 
    },
    {
      id: "2",
      number: "10254354545",
      itemname: "Cambo",
      desc:"Lorem ipsum dolor sit amet,  labore et dolore magna.",


    },
    {
      id: "3",
      number: "10254354545",
      itemname: "Avon Bulbs",
      desc:"Lorem ipsum dolor sit amet, consectetur amagna.",


    },
    {
      id: "4",
      number: "10254354545",
      itemname: "Broardleight Bulbs",
      desc:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna.",

    },
    {
      id: "5",
      number: "10254354545",
      itemname: "Dutch Grown",
      desc:"Lorem ipsum dolor sit amet,ncididunt ut labore et dolore magna.",

    },
  ];

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
      },

      {
        Header: "Number",
        accessor: "number",
      },
      {
        Header: "Item Name",
        accessor: "itemname",
      },
      
      {
        Header: "Description",
        accessor: "desc",
      },
      {
        Header: "Image",
        accessor: "img",
        Cell: ProductImageCell,
      },
      {
        Header: "Action",
        id: "action",
        accessor: "action",
        Cell: (value) => (
          <div className="flex flex-wrap">
          <div className=" text-gray-900 font-medium ">
            {" "}

            <button className="float-right mt-3">
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 12.1815C15 13.8391 13.654 15.1881 12 15.1881C10.346 15.1881 9 13.8391 9 12.1815C9 10.5239 10.346 9.17498 12 9.17498C13.654 9.17498 15 10.5239 15 12.1815ZM24 11.7315C24 11.7315 19.748 20.199 12.015 20.199C4.835 20.199 0 11.7315 0 11.7315C0 11.7315 4.446 4.16406 12.015 4.16406C19.709 4.16406 24 11.7315 24 11.7315ZM17 12.1815C17 9.41851 14.757 7.17061 12 7.17061C9.243 7.17061 7 9.41851 7 12.1815C7 14.9445 9.243 17.1924 12 17.1924C14.757 17.1924 17 14.9445 17 12.1815Z"
                  fill="#1F78B4"
                />
              </svg>
              </button>
          </div>
          
        </div>
        ),
      },
    ],
    []
  );

  return (
    <div className="mb-8 pb-4">
      <main className="max-w-full min-h-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="-mt-10">
          <BomTable
            columns={columns}
            data={data == undefined ? [] : data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default BomData;
